<template>
  <el-row>
    <el-collapse
      v-model="activeName"
      accordion
    >
      <el-collapse-item
        title="Legenda"
        name="legenda"
      >
        <el-row>
            <UploadLegenda
                label="Aguardando"
                description="Relatório ainda não começou a ser processado"
            />
            <UploadLegenda
                label="Processando"
                description="Relatório está sendo processado"
                color="primary"
            />
            <UploadLegenda
                label="Finalizado"
                description="Relatório foi processado"
                color="success"
            />
            <UploadLegenda
                label="Erro"
                description="Relatório foi processado com erro"
                color="danger"
            />
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </el-row>
</template>

<script>
import UploadLegenda from '../Upload/UploadLegenda'

export default {
  name: "RelatorioStatus",
  components: {
    UploadLegenda
  },
  data () {
    return {
      activeName: 'legenda',
      filtros: {
        dataCriacao: "",
        status: "",
        tipoArquivo: "",
      },
      tableData: [],
      loading: false,
      statusOption: [{
        value: 'processando',
        label: 'Processando'
      }, {
        value: 'finalizado',
        label: 'Finalizado'
      }, {
        value: 'aguardando',
        label: 'Aguardando'
      }, 
      {
        value: 'erro',
        label: 'Erro'
      }]
    };
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}

.loading {
  height: 10vh;
}
</style>
